import { DotCmsContainerState } from '../../store/dotcms-container/dotcms-container.reducer';
import { CustomDotCmsContentletHelper } from '../contentlet/custom-dot-cms-contentlet.helper';
import { CustomDotCmsContentlet } from '../contentlet/custom-dotcms-contentlet.model';

import {
  CustomDotCMSLayout,
  CustomDotCmsAssignedContentlet,
  CustomDotCmsPage,
  CustomDotCmsPageAsset,
} from './custom-dot-cms-page.model';

// eslint-disable-next-line ish-custom-rules/project-structure
export class CustomDotCmsPageMapper {
  static fromData(pageData: CustomDotCmsPageAsset): [CustomDotCmsPage, CustomDotCmsContentlet[], DotCmsContainerState] {
    const page: CustomDotCmsPage = {
      pageLayout: CustomDotCmsPageMapper.mapContentletIdentifierToLayoutContainers(pageData),
      metaInfo: pageData.page,
      urlContentMap: pageData?.urlContentMap,
    };
    const contentlets: CustomDotCmsContentlet[] = [];
    const containerData: DotCmsContainerState = {};

    if (pageData?.urlContentMap) {
      contentlets.push(
        ...CustomDotCmsContentletHelper.getSubContentlet(pageData.urlContentMap as unknown as CustomDotCmsContentlet)
      );
    }

    Object.entries(pageData?.containers).forEach(([containerKey, container]) => {
      //@ts-ignore
      containerData[containerKey] = {
        container: container.container,
        containerStructures: container.containerStructures,
      };
      Object.values(container?.contentlets).forEach(containerContentlets =>
        containerContentlets.forEach(contentlet =>
          contentlets.push(...CustomDotCmsContentletHelper.getSubContentlet(contentlet))
        )
      );
    });

    return [page, contentlets, containerData];
  }

  private static mapContentletIdentifierToLayoutContainers(pageData: CustomDotCmsPageAsset): CustomDotCMSLayout {
    const layout: CustomDotCMSLayout = structuredClone(pageData.layout as CustomDotCMSLayout);

    const isUrlContentMapPresent = !!pageData.urlContentMap;

    layout.body.rows.forEach(row => {
      row.columns.forEach(column => {
        Object.values(column.containers).forEach(container => {
          const assignedContentlets: CustomDotCmsAssignedContentlet[] = [];
          let contentlets = pageData?.containers[container.identifier]?.contentlets[`uuid-${container.uuid}`];

          if (isUrlContentMapPresent) {
            contentlets = [contentlets[0]];
          }

          contentlets?.forEach(contentlet =>
            assignedContentlets.push({
              identifier: isUrlContentMapPresent ? pageData.urlContentMap.identifier : contentlet.identifier,
              contentType: isUrlContentMapPresent ? pageData.urlContentMap.contentType : contentlet.contentType,
            })
          );

          container.assignedContentlets = assignedContentlets;
        });
      });
    });

    return layout;
  }
}
